// const Baseurl = "https://ecartweb.onrender.com"
//const Baseurl = "http://localhost:5001"
const key = 'rzp_test_kk3oYss2Ku6gIs'
const Baseurl = "https://api.imoxkitchen.com"
export {
    Baseurl,
    key
}